import React from 'react';

import { Breadcrumbs } from 'components/util/BreadCrumb';
import Header from 'components/util/cabecario/.mixins';

import { useHelmet } from 'hooks';
import type { IRouterProps } from 'pages/orderHistory';

interface ITopBarProps extends IRouterProps {
  productName?: string;
}

export const TopBar = ({ productName, router }: ITopBarProps) => {
  useHelmet({ title: ` ${process.env.REACT_APP_TITLE} - Histórico de agendamento` });

  function goBack() {
    router.push('/historico-de-agendamento');
  }

  return (
    <>
      <Header title={productName} goBack={goBack} />

      <Breadcrumbs
        breadcrumbs={[
          {
            label: 'Histórico de agendamento',
            href: 'historico-de-agendamento'
          },
          {
            label: productName,
            href: '/'
          }
        ]}
      />
    </>
  );
};
